(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name finance.vcprivcat.factory:PrivcatHelper
   *
   * @description
   *
   */
  angular
    .module('vcfinance.privcat')
    .factory('PrivcatHelper', PrivcatHelper);


  PrivcatHelper.$inject = ['Privcat', '$uibModal', '$log', 'Rlog'];

  function PrivcatHelper(Privcat, $uibModal, $log, Rlog) {
    let PrivcatHelperBase = {};

    PrivcatHelperBase.editPrivcatEntry = editPrivcatEntry;
    PrivcatHelperBase.addPrivcatEntry = addPrivcatEntry;
    PrivcatHelperBase.editPrivcatGroup = editPrivcatGroup;
    PrivcatHelperBase.addPrivcatGroup = addPrivcatGroup;


    function addPrivcatEntry(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><privcatform privcat="vm.privcat" parentsave="vm.childsave(privcat)" oncancel="vm.cancel()"></privcatnew></div>',
        controllerAs: 'privcataCtrl',
        controller: ['privcat', function () {
          let vm = this;
          vm.privcat = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(privcat) {
            Privcat.$create(privcat).$then(function (newprivcat) {
              vm.created = true;
              success(newprivcat);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ privcat-helper.addPrivcat: ', err);
              Rlog.error('vcutils.privcat', 'privcat-helper.addPrivcat', 'Creation of new SV failed: ', {
                error: err,
                privcat: privcat
              });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }

        }],
        resolve: {
          privcat: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }


    function editPrivcatEntry(lprivcat) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><privcatentryform privcatentry="privcateCtrl.privcat" parentsave="privcateCtrl.childsave(privcatentry)" oncancel="privcateCtrl.cancel()"></privcatentryform></div>',
        controllerAs: 'privcateCtrl',
        controller: ['privcat', function (sprivcat) {
          let vm = this;
          vm.privcat = sprivcat;
          vm.childsave = childsave;
          vm.cancel = cancel;


          function childsave(privcatentry) {
            // vm.privcat = angular.copy(privcat);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in privcatentry) {
              if (privcatentry.hasOwnProperty(key)) {
                vm.privcat[key] = privcatentry[key];
              }
            }

            if (vm.privcat.$hasPendingActions()) {
              vm.privcat.$cancel();
              vm.privcat.$save();
              cancel();
            }
            else {
              vm.privcat.$save();
              dialog.close();
            }
          }


          function cancel() {
            dialog.close();
          }


        }],
        resolve: {
          privcat: function () {
            return lprivcat;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    function addPrivcatGroup(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><privcatform privcat="vm.privcat" parentsave="vm.childsave(privcat)" oncancel="vm.cancel()"></privcatnew></div>',
        controllerAs: 'privcataCtrl',
        controller: ['privcat', function () {
          let vm = this;
          vm.privcat = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(privcat) {
            Privcat.$create(privcat).$then(function (newprivcat) {
              vm.created = true;
              success(newprivcat);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ privcat-helper.addPrivcat: ', err);
              Rlog.error('vcutils.privcat', 'privcat-helper.addPrivcat', 'Creation of new SV failed: ', {
                error: err,
                privcat: privcat
              });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }

        }],
        resolve: {
          privcat: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }


    function editPrivcatGroup(lprivcat) {
      let dialog = $uibModal.open({
        template: `
<div class="panel panel-default"><div class="panel-heading">
<span class="pull-left">Leistungsgrupp editieren</span>
<span class="pull-right"><span class="btn btn-danger btn-xs" ng-click="privcateCtrl.dialog.close()"><i class="fa fa-remove"></i></span>  </span>
<div class="clearfix"></div>
</div>
<div class="panel-body">
            <div class="modalspacer">
                <privcatgroupform privcatgroup="privcateCtrl.privcat" 
                                  parentsave="privcateCtrl.childsave(privcatgroup)" 
                                  oncancel="privcateCtrl.cancel()">
                </privcatgroupform>
            </div>


</div> </div>`,
        controllerAs: 'privcateCtrl',
        controller: ['privcat', '$uibModalInstance', function (sprivcat, dialog) {
          let vm = this;
          vm.privcat = sprivcat;
          vm.dialog = dialog;
          vm.childsave = childsave;
          vm.cancel = cancel;


          function childsave(privcatgroup) {
            $log.debug('helper childsave saving group: ', privcatgroup);
            // vm.privcat = angular.copy(privcat);
            // the above code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in privcatgroup) {
              if (privcatgroup.hasOwnProperty(key)) {
                vm.privcat[key] = privcatgroup[key];
              }
            }
            $log.debug('helper childsave saving vm.privcat: ', vm.privcat);
            if (vm.privcat.$hasPendingActions()) {
              vm.privcat.$cancel();
              vm.privcat.$save();
              cancel();
            }
            else {
              vm.privcat.$save();
              dialog.close();
            }
          }


          function cancel() {
            dialog.close();
          }


        }],
        resolve: {
          privcat: function () {
            return lprivcat;
          }
        },
        size: 'lg',
        backdrop: 'static'
      });
      return dialog;
    }

    return PrivcatHelperBase;
  }
}());
